import PhotoArrows from '../src/PhotoArrows.tsx';
export default PhotoArrows;
